<app-header [headerText]="employeeInfo"></app-header>
<button mat-fab color="primary" aria-label="return" [routerLink]="['./../../dashboard', employeeNumber]">
  <mat-icon>keyboard_arrow_left</mat-icon>
</button>
<mat-tab-group class="parent" mat-align-tabs="center" animationDuration="0ms" dynamicHeight=true
  (selectedTabChange)="tabChanged($event)" [selectedIndex]="contentLocation.tabIndex" *ngIf="currentEmployee">

  <mat-tab>

    <ng-template mat-tab-label>
      <img class="img-responsive center-block" src="{{caja}}" />
    </ng-template>

    <mat-tab-group class="child" animationDuration="0ms" dynamicHeight="true"
      [selectedIndex]="contentLocation.detailIndex" (selectedTabChange)="subTabChangeSavings($event)">

      <mat-tab></mat-tab>

      <mat-tab [disabled]="shouldDisablePermanentSavingButton">

        <ng-template mat-tab-label>
          <div><img class="img-responsive center-block" src="{{cajaIcon}}" [matTooltip]="permanentSavingDisabledReason"
              aria-label="mensaje" matTooltipPosition="above" [matTooltipDisabled]="!shouldDisablePermanentSavingButton"
              [matBadgeHidden]="!shouldDisablePermanentSavingButton" matBadge="?" matBadgePosition="after"
              matBadgeColor="accent" matBadgeSize="large" /></div>
          Caja De Ahorro<br>Permanente<br>&nbsp;
        </ng-template>
        <app-ps-registration [contentLocation]="contentLocation"
          *ngIf="(contentLocation.tabIndex === 0 && contentLocation.detailIndex === 1) && !activeStatusPermanentSavings">
        </app-ps-registration>
        <app-ps-details [contentLocation]="contentLocation"
          *ngIf="(contentLocation.tabIndex === 0 && contentLocation.detailIndex === 1) && activeStatusPermanentSavings ">
        </app-ps-details>


      </mat-tab>

      <mat-tab *ngIf="!shouldHideRetirementSavings">

        <ng-template mat-tab-label>
          <div><img class="img-responsive center-block" src="{{cajaIcon}}" /></div>
          Caja De Ahorro<br>Retiro<br>&nbsp;
        </ng-template>

        <app-rs-statement *ngIf="(contentLocation.tabIndex === 0 && contentLocation.detailIndex === 2)">
        </app-rs-statement>


      </mat-tab>


      <mat-tab [disabled]="shareSavingsDisabled" *ngIf="shareSavingsHide && shareSavingsParameters">

        <ng-template mat-tab-label>
          <div><img class="img-responsive center-block"
              matTooltip="En este momento se encuentra fuera del periodo de adquisición." aria-label="mensaje"
              matTooltipPosition="above" [matTooltipDisabled]="!shareSavingsDisabled" src="{{cajaIcon}}" /></div>
          Inversión<br>Por Acciones<br>&nbsp;
        </ng-template>

        <div>
          <app-ss-user [shareSavingsParameters]="shareSavingsParameters" [contentLocation]="contentLocation"
          *ngIf="(contentLocation.tabIndex === 0 && contentLocation.detailIndex !== 1)">
          </app-ss-user>


        </div>
      </mat-tab>

    </mat-tab-group>

  </mat-tab>

  <mat-tab>

    <ng-template mat-tab-label>
      <img class="img-responsive center-block" src="{{prestamos}}" />
    </ng-template>

    <mat-tab-group class="child" animationDuration="0ms" dynamicHeight="true"
      [selectedIndex]="contentLocation.detailIndex" (selectedTabChange)="subTabChangeLoans($event)">

      <mat-tab></mat-tab>

      <mat-tab [disabled]="shouldDisablePermanentLoanButton">

        <ng-template mat-tab-label>
          <div><img [matTooltip]="permanentSavingLoanDisabledReason" aria-label="mensaje" matTooltipPosition="above"
              [matTooltipDisabled]="!shouldDisablePermanentLoanButton"
              [matBadgeHidden]="!shouldDisablePermanentLoanButton" matBadge="?" matBadgePosition="after"
              matBadgeColor="accent" matBadgeSize="large" class="img-responsive center-block" src="{{prestamosIcon}}" />
          </div>
          Caja De Ahorro<br>Permanente<br>&nbsp;
        </ng-template>

        <app-pl-request [contentLocation]="contentLocation"
          *ngIf="!currentEmployee.permanentSavingsLoan && (contentLocation.tabIndex === 1 && contentLocation.detailIndex === 1)">
        </app-pl-request>
        <app-pl-details [contentLocation]="contentLocation"
          *ngIf="currentEmployee.permanentSavingsLoan && (contentLocation.tabIndex === 1 && contentLocation.detailIndex === 1)">
        </app-pl-details>


      </mat-tab>

      <mat-tab *ngIf="!shouldHideRetirementLoan">

        <ng-template mat-tab-label>
          <div><img class="img-responsive center-block" src="{{prestamosIcon}}"
              [matTooltip]="retirementSavingLoanDisabledReason" aria-label="mensaje" matTooltipPosition="above"
              [matTooltipDisabled]="!shouldDisableRetirementLoanButton"
              [matBadgeHidden]="!shouldDisableRetirementLoanButton" matBadge="?" matBadgePosition="after"
              matBadgeColor="accent" matBadgeSize="large" /></div>
          Caja De Ahorro<br>Retiro<br>&nbsp;
        </ng-template>


        <app-rl-request [contentLocation]="contentLocation"
          *ngIf="!currentEmployee.retirementSavingsLoan && (contentLocation.tabIndex === 1 && contentLocation.detailIndex === 2)">
        </app-rl-request>
        <app-rl-details [contentLocation]="contentLocation"
          *ngIf="currentEmployee.retirementSavingsLoan && (contentLocation.tabIndex === 1 && contentLocation.detailIndex === 2)">
        </app-rl-details>


      </mat-tab>

    </mat-tab-group>

  </mat-tab>

  <mat-tab>

    <ng-template mat-tab-label>
      <img class="img-responsive center-block" src="{{fondo}}" />
    </ng-template>

    <mat-tab-group class="child" animationDuration="0ms" dynamicHeight="true"
      [selectedIndex]="contentLocation.detailIndex" (selectedTabChange)="subTabChangeFunds($event)">

      <mat-tab></mat-tab>

      <mat-tab [disabled]="shouldDisableLongFund">

        <ng-template mat-tab-label>
          <div><img class="img-responsive center-block" src="{{fondoIcon}}"
              matTooltip="No existen datos en los acumulados del colaborador para este ciclo" aria-label="mensaje"
              matTooltipPosition="above" [matTooltipDisabled]="!shouldDisableLongFund"
              [matBadgeHidden]="!shouldDisableLongFund" matBadge="?" matBadgePosition="after" matBadgeColor="accent"
              matBadgeSize="large" /></div>
          Fondo De Ahorro<br>Largo<br>&nbsp;
        </ng-template>

        <app-lsf-statement type="FAL" *ngIf="contentLocation.tabIndex === 2 && contentLocation.detailIndex === 1">
        </app-lsf-statement>


      </mat-tab>

      <mat-tab *ngIf="!hideShortFund">

        <ng-template mat-tab-label>
          <div><img class="img-responsive center-block" src="{{fondoIcon}}"
              matTooltip="No existen datos en los acumulados del colaborador para este ciclo" aria-label="mensaje"
              matTooltipPosition="above" [matTooltipDisabled]="!shouldDisableShortFund"
              [matBadgeHidden]="!shouldDisableShortFund" matBadge="?" matBadgePosition="after" matBadgeColor="accent"
              matBadgeSize="large" /></div>
          Fondo De Ahorro<br>Corto<br>&nbsp;
        </ng-template>

        <app-lsf-statement type="FAC" *ngIf="contentLocation.tabIndex === 2 && contentLocation.detailIndex === 2">
        </app-lsf-statement>

      </mat-tab>

    </mat-tab-group>

  </mat-tab>

  <mat-tab>

    <ng-template mat-tab-label>
      <img class="img-responsive center-block" src="{{general}}" />
    </ng-template>

    <h5 class="mb-4">Información General:</h5>
    <app-employee-general-information [disabled]="true" [employee]="currentEmployee">
    </app-employee-general-information>
    <h5 class="mb-4">Información De Contacto:</h5>
    <app-contact-information [disabled]="true" [contactInformation]="currentEmployee.contactInformation">
    </app-contact-information>

  </mat-tab>

  <mat-tab>

    <ng-template mat-tab-label>
      <img class="img-responsive center-block" src="{{laboral}}" />
    </ng-template>

    <h5 class="mb-4">Supervisor:</h5>
    <app-employee-ref [disabled]="true" [employeeRef]="currentEmployee.workInformation.supervisor"></app-employee-ref>
    <h5 class="mb-4">Información Laboral:</h5>
    <app-work-information [disabled]="true" [workInformation]="currentEmployee.workInformation">
    </app-work-information>

    <h5 class="mb-4">Ultimas Nominas Registradas:</h5>

    <div *ngIf="currentEmployee" class="row">
      <div class="col-md-12">

        <mat-table *ngIf="payrollContributions && payrollContributions.length > 0; else noPaymentHistory"
          [dataSource]="payrollContributions" class="table border">

          <ng-container matColumnDef="date">
            <mat-header-cell *matHeaderCellDef> Fecha </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.date | UtcPipe }} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="amount">
            <mat-header-cell *matHeaderCellDef> Importe Recibido </mat-header-cell>x
            <mat-cell *matCellDef="let element"> {{element.amount | number: '.2-2'}} </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

        </mat-table>

        <ng-template #noPaymentHistory>

          <div class="text-center noActions">
            <h5 class="mt-1">No Existe Historial De Pagos De Este Colaborador</h5>
            <mat-icon aria-hidden="true">clear</mat-icon>
          </div>

        </ng-template>

      </div>
    </div>


  </mat-tab>

</mat-tab-group>